export default "__VITE_ASSET__sp8hRo6O__"